import {
    ConversationItem,
    ConversationSpec,
    Block
} from '../../entities/conversation'

export type Cursor = Array<string | number>

export interface Scope {
    [key: string]: boolean | string[] // option keys if a ReceiveOption
}

export interface OptionScope {
    [key: string]: string[]
}

export type SpecNode = ConversationItem | Block

export interface Visited {
    [label: string]: boolean
}

export interface NodePath {
    node: SpecNode
    cursor: Cursor
    scope: Scope
}

export function getNode(spec: ConversationSpec, cursor: Cursor): ConversationItem | Block | undefined {

    const keys = [ ...cursor ] // need to copy cursor so we don't mutate it
    let ref: ConversationItem | ConversationSpec = spec

    while (keys.length > 0) {
        const key = keys.shift()
        if (ref !== undefined && key !== undefined) {
            ref = ref[key]
        }
    }

    return ref as ConversationItem
}

export function initialCursor(spec: ConversationSpec): Cursor {
    return findBlockCursor(spec, 'start') || [0]
}

export function findBlockCursor(spec: ConversationSpec, label: string): Cursor | undefined {
    for (let i = 0; i < spec.length; i++) {
        const item = spec[i]
        if (item.type === 'Block' && item.label === label) {
            return [i, 'items', 0] // reset to top level
        }
    }
}

// get the latest numeric key in the cursor and try to increment it
// if there is a node there, return the cursor to it
// this walks down lists of items, and returns control to the closest
// parent if the list is finished
export function getNextCursorDownstream(
    spec: ConversationSpec,
    cursor: Cursor,
    node: SpecNode
): Cursor | undefined {

    for (let i = cursor.length - 1; i >= 0; i--) { // start at the end and go <-

        const key = cursor[i]

        if (typeof key === 'number') {

            const nextCursor = cursor.slice(0, i).concat([key + 1])
            const nextNode = getNode(spec, nextCursor)

            if (nextNode && nextNode !== node) { return nextCursor }
        }
    }
}
